"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1545],{

/***/ 77349:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ addDays; }
/* harmony export */ });
/* harmony import */ var _lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(83946);
/* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19013);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13882);



/**
 * @name addDays
 * @category Day Helpers
 * @summary Add the specified number of days to the given date.
 *
 * @description
 * Add the specified number of days to the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of days to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} - the new date with the days added
 * @throws {TypeError} - 2 arguments required
 *
 * @example
 * // Add 10 days to 1 September 2014:
 * const result = addDays(new Date(2014, 8, 1), 10)
 * //=> Thu Sep 11 2014 00:00:00
 */
function addDays(dirtyDate, dirtyAmount) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(2, arguments);
  var date = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(dirtyDate);
  var amount = (0,_lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(dirtyAmount);
  if (isNaN(amount)) {
    return new Date(NaN);
  }
  if (!amount) {
    // If 0 days, no-op to avoid changing times in the hour before end of DST
    return date;
  }
  date.setDate(date.getDate() + amount);
  return date;
}

/***/ }),

/***/ 92300:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ differenceInCalendarDays; }
/* harmony export */ });
/* harmony import */ var _lib_getTimezoneOffsetInMilliseconds_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(24262);
/* harmony import */ var _startOfDay_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(69119);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13882);



var MILLISECONDS_IN_DAY = 86400000;

/**
 * @name differenceInCalendarDays
 * @category Day Helpers
 * @summary Get the number of calendar days between the given dates.
 *
 * @description
 * Get the number of calendar days between the given dates. This means that the times are removed
 * from the dates and then the difference in days is calculated.
 *
 * @param {Date|Number} dateLeft - the later date
 * @param {Date|Number} dateRight - the earlier date
 * @returns {Number} the number of calendar days
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // How many calendar days are between
 * // 2 July 2011 23:00:00 and 2 July 2012 00:00:00?
 * const result = differenceInCalendarDays(
 *   new Date(2012, 6, 2, 0, 0),
 *   new Date(2011, 6, 2, 23, 0)
 * )
 * //=> 366
 * // How many calendar days are between
 * // 2 July 2011 23:59:00 and 3 July 2011 00:01:00?
 * const result = differenceInCalendarDays(
 *   new Date(2011, 6, 3, 0, 1),
 *   new Date(2011, 6, 2, 23, 59)
 * )
 * //=> 1
 */
function differenceInCalendarDays(dirtyDateLeft, dirtyDateRight) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(2, arguments);
  var startOfDayLeft = (0,_startOfDay_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(dirtyDateLeft);
  var startOfDayRight = (0,_startOfDay_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(dirtyDateRight);
  var timestampLeft = startOfDayLeft.getTime() - (0,_lib_getTimezoneOffsetInMilliseconds_index_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(startOfDayLeft);
  var timestampRight = startOfDayRight.getTime() - (0,_lib_getTimezoneOffsetInMilliseconds_index_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(startOfDayRight);

  // Round the number of days to the nearest integer
  // because the number of milliseconds in a day is not constant
  // (e.g. it's different in the day of the daylight saving time clock shift)
  return Math.round((timestampLeft - timestampRight) / MILLISECONDS_IN_DAY);
}

/***/ }),

/***/ 42699:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ isAfter; }
/* harmony export */ });
/* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19013);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13882);


/**
 * @name isAfter
 * @category Common Helpers
 * @summary Is the first date after the second one?
 *
 * @description
 * Is the first date after the second one?
 *
 * @param {Date|Number} date - the date that should be after the other one to return true
 * @param {Date|Number} dateToCompare - the date to compare with
 * @returns {Boolean} the first date is after the second date
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Is 10 July 1989 after 11 February 1987?
 * const result = isAfter(new Date(1989, 6, 10), new Date(1987, 1, 11))
 * //=> true
 */
function isAfter(dirtyDate, dirtyDateToCompare) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(2, arguments);
  var date = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(dirtyDate);
  var dateToCompare = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(dirtyDateToCompare);
  return date.getTime() > dateToCompare.getTime();
}

/***/ }),

/***/ 313:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ isBefore; }
/* harmony export */ });
/* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19013);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13882);


/**
 * @name isBefore
 * @category Common Helpers
 * @summary Is the first date before the second one?
 *
 * @description
 * Is the first date before the second one?
 *
 * @param {Date|Number} date - the date that should be before the other one to return true
 * @param {Date|Number} dateToCompare - the date to compare with
 * @returns {Boolean} the first date is before the second date
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Is 10 July 1989 before 11 February 1987?
 * const result = isBefore(new Date(1989, 6, 10), new Date(1987, 1, 11))
 * //=> false
 */
function isBefore(dirtyDate, dirtyDateToCompare) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(2, arguments);
  var date = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(dirtyDate);
  var dateToCompare = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(dirtyDateToCompare);
  return date.getTime() < dateToCompare.getTime();
}

/***/ }),

/***/ 69119:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ startOfDay; }
/* harmony export */ });
/* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19013);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13882);


/**
 * @name startOfDay
 * @category Day Helpers
 * @summary Return the start of a day for the given date.
 *
 * @description
 * Return the start of a day for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the start of a day
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The start of a day for 2 September 2014 11:55:00:
 * const result = startOfDay(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 02 2014 00:00:00
 */
function startOfDay(dirtyDate) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(1, arguments);
  var date = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__["default"])(dirtyDate);
  date.setHours(0, 0, 0, 0);
  return date;
}

/***/ }),

/***/ 7069:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ subDays; }
/* harmony export */ });
/* harmony import */ var _addDays_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(77349);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13882);
/* harmony import */ var _lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(83946);



/**
 * @name subDays
 * @category Day Helpers
 * @summary Subtract the specified number of days from the given date.
 *
 * @description
 * Subtract the specified number of days from the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of days to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the days subtracted
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Subtract 10 days from 1 September 2014:
 * const result = subDays(new Date(2014, 8, 1), 10)
 * //=> Fri Aug 22 2014 00:00:00
 */
function subDays(dirtyDate, dirtyAmount) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(2, arguments);
  var amount = (0,_lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(dirtyAmount);
  return (0,_addDays_index_js__WEBPACK_IMPORTED_MODULE_2__["default"])(dirtyDate, -amount);
}

/***/ }),

/***/ 61486:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "PostShowMainTabiChat": function() { return /* binding */ PostShowMainTabiChat; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(70917);
/* harmony import */ var main_javascripts_components_molecules_Post_EditorProfile__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(61586);
/* harmony import */ var main_javascripts_features_post_components_TagList__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(93933);
/* harmony import */ var main_javascripts_components_molecules_Post_RegionTagList__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(25177);
/* harmony import */ var main_javascripts_components_molecules_Post_TableOfContents_TableOfContents__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(95454);
/* harmony import */ var main_javascripts_components_molecules_Post_PopularTagList__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(68314);
/* harmony import */ var main_javascripts_features_post_components_RankingList__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(39523);
/* harmony import */ var main_javascripts_features_post_components_RelatedPostList__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(46685);
/* harmony import */ var main_javascripts_components_molecules_Post_FixedLineButton__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(35179);
/* harmony import */ var main_javascripts_features_post_components_Search__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(26093);
/* harmony import */ var main_javascripts_store__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(79169);
/* harmony import */ var _postSlice__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(78121);
/* harmony import */ var main_javascripts_styles_base_colorStyle__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(80910);
/* harmony import */ var main_javascripts_styles_base_responsiveStyle__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(88433);
/* harmony import */ var main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(96749);
/* harmony import */ var main_javascripts_styles_base_typographyStyle__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(36716);
/* harmony import */ var _PostContent__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(50021);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(35944);
function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }





















var PostShowMainTabiChat = function PostShowMainTabiChat(props) {
  var _post$searchTypes;

  var html = props.html;
  var post = (0,main_javascripts_store__WEBPACK_IMPORTED_MODULE_10__/* .useAppSelector */ .CG)(_postSlice__WEBPACK_IMPORTED_MODULE_11__/* .postSelector */ .pm);

  var renderTags = function renderTags() {
    var hasTags = post.tags.length > 0 || post.regions.length > 0;

    if (!hasTags) {
      return null;
    }

    return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__/* .jsxs */ .BX)("div", {
      css: tagBlockStyle,
      children: [post.tags.length > 0 && (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__/* .jsx */ .tZ)("div", {
        css: tagListBlockStyle,
        children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__/* .jsx */ .tZ)(main_javascripts_features_post_components_TagList__WEBPACK_IMPORTED_MODULE_2__/* .TagList */ .P, {
          tags: post.tags
        })
      }), post.regions.length > 0 && (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__/* .jsx */ .tZ)(main_javascripts_components_molecules_Post_RegionTagList__WEBPACK_IMPORTED_MODULE_3__/* .RegionTagList */ .N, {
        regions: post.regions,
        disableLink: true
      })]
    });
  };

  var hasSearchTypes = ((_post$searchTypes = post.searchTypes) === null || _post$searchTypes === void 0 ? void 0 : _post$searchTypes.length) > 0;
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__/* .jsx */ .tZ)("div", {
    css: blockStyle,
    children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__/* .jsxs */ .BX)("main", {
      css: innerStyle,
      children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__/* .jsxs */ .BX)("div", {
        css: mainStyle,
        children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__/* .jsxs */ .BX)("article", {
          css: postBlockStyle,
          children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__/* .jsx */ .tZ)("header", {
            children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__/* .jsxs */ .BX)("div", {
              css: headerInnerStyle,
              children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__/* .jsx */ .tZ)("h1", {
                css: postTitleStyle,
                children: post.title
              }), post.summary && (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__/* .jsx */ .tZ)("div", {
                css: postSummaryStyle,
                children: post.summary
              }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__/* .jsx */ .tZ)(main_javascripts_features_post_components_Search__WEBPACK_IMPORTED_MODULE_9__/* .Search */ .o, {}), post.featuredImage && (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__/* .jsx */ .tZ)("div", {
                css: featuredImageBlockStyle,
                children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__/* .jsx */ .tZ)("img", {
                  css: featuredImageStyle,
                  src: post.featuredImage.url,
                  alt: post.title
                })
              })]
            })
          }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__/* .jsx */ .tZ)(main_javascripts_components_molecules_Post_TableOfContents_TableOfContents__WEBPACK_IMPORTED_MODULE_4__/* .TableOfContents */ .o, {
            editorStateJson: post.content.editorStateJson
          }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__/* .jsx */ .tZ)("section", {
            css: contentBlockStyle,
            children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__/* .jsx */ .tZ)(_PostContent__WEBPACK_IMPORTED_MODULE_16__/* .PostContent */ .C, {
              html: html
            })
          }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__/* .jsxs */ .BX)("section", {
            css: contentBlockStyle,
            children: [renderTags(), post.editor && (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__/* .jsx */ .tZ)("div", {
              css: editorProfileBlockStyle,
              children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__/* .jsx */ .tZ)(main_javascripts_components_molecules_Post_EditorProfile__WEBPACK_IMPORTED_MODULE_1__/* .EditorProfile */ .e, {
                editor: post.editor,
                updatedAt: post.updatedAt
              })
            })]
          })]
        }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__/* .jsx */ .tZ)("section", {
          css: postBottomBlockStyle,
          children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__/* .jsx */ .tZ)(main_javascripts_features_post_components_RelatedPostList__WEBPACK_IMPORTED_MODULE_7__/* .RelatedPostList */ .K, {
            posts: post.relatedPosts
          })
        })]
      }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__/* .jsxs */ .BX)("div", {
        css: sideStyle,
        children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__/* .jsx */ .tZ)("div", {
          css: popularTagsBlockStyle,
          children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__/* .jsx */ .tZ)(main_javascripts_components_molecules_Post_PopularTagList__WEBPACK_IMPORTED_MODULE_5__/* .PopularTagList */ .O, {
            tags: post.popularTags
          })
        }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__/* .jsx */ .tZ)("div", {
          css: rankingBlockStyle,
          children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__/* .jsx */ .tZ)(main_javascripts_features_post_components_RankingList__WEBPACK_IMPORTED_MODULE_6__/* .RankingList */ .S, {
            rankings: post.rankings
          })
        })]
      }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__/* .jsx */ .tZ)(main_javascripts_components_molecules_Post_FixedLineButton__WEBPACK_IMPORTED_MODULE_8__/* .FixedLineButton */ .c, {
        lineFooterText: post.lineFooterText,
        hasSearchTypes: hasSearchTypes,
        post: post
      })]
    })
  });
};
var blockStyle = /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_18__.css)("background-color:", main_javascripts_styles_base_colorStyle__WEBPACK_IMPORTED_MODULE_12__/* .backgroundColor.secondaryLightColor */ .Cz.secondaryLightColor, ";", (0,main_javascripts_styles_base_responsiveStyle__WEBPACK_IMPORTED_MODULE_13__/* .moreThanBreakpoint */ .h6)("desktop"), "{min-height:calc(100vh - 357px);}" + ( true ? "" : 0),  true ? "" : 0);
var innerStyle = /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_18__.css)("max-width:50rem;margin:0 auto;padding:", main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_14__/* .space.atom */ .D.atom, " 0;", (0,main_javascripts_styles_base_responsiveStyle__WEBPACK_IMPORTED_MODULE_13__/* .moreThanBreakpoint */ .h6)("tablet"), "{padding:", main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_14__/* .space.atom3x */ .D.atom3x, " ", main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_14__/* .space.atom3x */ .D.atom3x, ";}", (0,main_javascripts_styles_base_responsiveStyle__WEBPACK_IMPORTED_MODULE_13__/* .moreThanBreakpoint */ .h6)("desktop"), "{max-width:72rem;display:flex;justify-content:space-between;padding:", main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_14__/* .space.atom3x */ .D.atom3x, " ", main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_14__/* .space.atom3x */ .D.atom3x, " 3rem;}" + ( true ? "" : 0),  true ? "" : 0);
var mainStyle = /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_18__.css)("width:100%;", (0,main_javascripts_styles_base_responsiveStyle__WEBPACK_IMPORTED_MODULE_13__/* .moreThanBreakpoint */ .h6)("desktop"), "{width:calc(100% - 21.5rem);}" + ( true ? "" : 0),  true ? "" : 0);
var sideStyle = /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_18__.css)("padding-top:", main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_14__/* .space.atom4x */ .D.atom4x, ";", (0,main_javascripts_styles_base_responsiveStyle__WEBPACK_IMPORTED_MODULE_13__/* .moreThanBreakpoint */ .h6)("desktop"), "{padding-top:0;width:20rem;}" + ( true ? "" : 0),  true ? "" : 0);
var postBlockStyle =  true ? {
  name: "dfjll8",
  styles: "background-color:#fff"
} : 0;
var headerInnerStyle = /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_18__.css)("padding:", main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_14__/* .space.atom */ .D.atom, " ", main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_14__/* .space.atom */ .D.atom, " 0;", (0,main_javascripts_styles_base_responsiveStyle__WEBPACK_IMPORTED_MODULE_13__/* .moreThanBreakpoint */ .h6)("tablet"), "{padding:", main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_14__/* .space.atom3x */ .D.atom3x, " ", main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_14__/* .space.atom3x */ .D.atom3x, " 0;}" + ( true ? "" : 0),  true ? "" : 0);
var featuredImageBlockStyle = /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_18__.css)("position:relative;padding:", main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_14__/* .space.atom3x */ .D.atom3x, " ", main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_14__/* .space.atom */ .D.atom, " ", main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_14__/* .space.atom2x */ .D.atom2x, ";" + ( true ? "" : 0),  true ? "" : 0);
var featuredImageStyle =  true ? {
  name: "1082qq3",
  styles: "display:block;width:100%"
} : 0;
var contentBlockStyle = /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_18__.css)("padding:", main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_14__/* .space.atom2x */ .D.atom2x, " ", main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_14__/* .space.atom */ .D.atom, ";", (0,main_javascripts_styles_base_responsiveStyle__WEBPACK_IMPORTED_MODULE_13__/* .moreThanBreakpoint */ .h6)("tablet"), "{padding:", main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_14__/* .space.atom2x */ .D.atom2x, " ", main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_14__/* .space.atom3x */ .D.atom3x, ";}" + ( true ? "" : 0),  true ? "" : 0);
var postTitleStyle = /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_18__.css)("font-size:", main_javascripts_styles_base_typographyStyle__WEBPACK_IMPORTED_MODULE_15__/* .fontSize.headline */ .JB.headline, ";line-height:", main_javascripts_styles_base_typographyStyle__WEBPACK_IMPORTED_MODULE_15__/* .lineHeight.headline1 */ .Nv.headline1, ";font-weight:", main_javascripts_styles_base_typographyStyle__WEBPACK_IMPORTED_MODULE_15__/* .fontWeight.bold */ .Ue.bold, ";color:", main_javascripts_styles_base_colorStyle__WEBPACK_IMPORTED_MODULE_12__/* .textColor.primaryDarkColor */ .zP.primaryDarkColor, ";padding:", main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_14__/* .space.atom */ .D.atom, " ", main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_14__/* .space.atom */ .D.atom, ";margin:0;", (0,main_javascripts_styles_base_responsiveStyle__WEBPACK_IMPORTED_MODULE_13__/* .moreThanBreakpoint */ .h6)("tablet"), "{font-size:1.75rem;line-height:1.5;}" + ( true ? "" : 0),  true ? "" : 0);
var postSummaryStyle = /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_18__.css)("margin:", main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_14__/* .space.atom */ .D.atom, " ", main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_14__/* .space.atom */ .D.atom, " ", main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_14__/* .space.atom2x */ .D.atom2x, ";padding:", main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_14__/* .space.atom2x */ .D.atom2x, " ", main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_14__/* .space.atom2x */ .D.atom2x, ";font-size:", main_javascripts_styles_base_typographyStyle__WEBPACK_IMPORTED_MODULE_15__/* .fontSize.body */ .JB.body, ";line-height:", main_javascripts_styles_base_typographyStyle__WEBPACK_IMPORTED_MODULE_15__/* .lineHeight.body1 */ .Nv.body1, ";color:", main_javascripts_styles_base_colorStyle__WEBPACK_IMPORTED_MODULE_12__/* .textColor.secondaryDarkColor */ .zP.secondaryDarkColor, ";background-color:", main_javascripts_styles_base_colorStyle__WEBPACK_IMPORTED_MODULE_12__/* .backgroundColor.subsectionColor */ .Cz.subsectionColor, ";", (0,main_javascripts_styles_base_responsiveStyle__WEBPACK_IMPORTED_MODULE_13__/* .moreThanBreakpoint */ .h6)("tablet"), "{margin-top:", main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_14__/* .space.atom2x */ .D.atom2x, ";}" + ( true ? "" : 0),  true ? "" : 0);
var editorProfileBlockStyle = /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_18__.css)("padding:", main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_14__/* .space.atom */ .D.atom, " ", main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_14__/* .space.atom */ .D.atom, " ", main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_14__/* .space.atom */ .D.atom, " 0;" + ( true ? "" : 0),  true ? "" : 0);
var tagBlockStyle = /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_18__.css)("padding:", main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_14__/* .space.atom */ .D.atom, " 0 0;" + ( true ? "" : 0),  true ? "" : 0);
var tagListBlockStyle = /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_18__.css)("padding:0 ", main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_14__/* .space.atom */ .D.atom, ";" + ( true ? "" : 0),  true ? "" : 0);
var popularTagsBlockStyle = /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_18__.css)("padding:0 0 ", main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_14__/* .space.atom2x */ .D.atom2x, ";" + ( true ? "" : 0),  true ? "" : 0);
var rankingBlockStyle = /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_18__.css)( true ? "" : 0,  true ? "" : 0);
var postBottomBlockStyle = /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_18__.css)("margin-top:", main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_14__/* .space.atom4x */ .D.atom4x, ";" + ( true ? "" : 0),  true ? "" : 0);

/***/ })

}]);